module.exports = __webpack_public_path__ + "img/landmark.7b34319e.svg";